/* ============================================================
   SPARC MOBILE CONFIGURATOR V4
   APPROVED MUSCLE MOBILE BASELINE
   ============================================================ */

(function () {
  "use strict";

  if (window.__SPARC_MOBILE_CONFIGURATOR_V4_BASELINE__) {
    return;
  }

  window.__SPARC_MOBILE_CONFIGURATOR_V4_BASELINE__ = true;


  /* ==========================================================
     STATE
     ========================================================== */

  var panel = null;
  var appbar = null;
  var hero = null;
  var dock = null;
  var descriptionView = null;

  var observer = null;
  var syncTimer = null;
  var syncInterval = null;

  var eventsInstalled = false;

  var configScrollPosition = 0;

  var lastPrice = "";
  var lastLead = "";
  var firstValueSync = true;


  var ORDER = [
    "finish",
    "grip",
    "leather",
    "horn",
    "mounting",
    "accessories",
    "summary"
  ];


  /* ==========================================================
     BASIC HELPERS
     ========================================================== */

  function q(selector, root) {
    return (root || document).querySelector(selector);
  }


  function qa(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(selector)
    );
  }


  function clean(value) {
    return String(value || "")
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }


  function normalize(value) {
    return clean(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "");
  }


  function make(tag, className, text) {
    var node = document.createElement(tag);

    if (className) {
      node.className = className;
    }

    if (text !== undefined) {
      node.textContent = text;
    }

    return node;
  }


  function isPhone() {
    var narrow =
      window.matchMedia &&
      window.matchMedia("(max-width: 767px)").matches;

    var phoneUA =
      /iPhone|iPod|Android.*Mobile|Windows Phone/i.test(
        navigator.userAgent || ""
      );

    return narrow || phoneUA;
  }


  function getPanel() {
    return document.getElementById(
      "sparc-muscle-configurator"
    );
  }


  /* ==========================================================
     CONFIGURATOR SECTIONS
     ========================================================== */

  function section(name) {
    if (!panel) {
      return null;
    }

    return q(
      '.sparc-accordion[data-section="' +
      name +
      '"]',
      panel
    );
  }


  function currentOpenName() {
    if (!panel) {
      return "finish";
    }

    var open = qa(
      ".sparc-accordion[data-section]",
      panel
    ).find(function (node) {
      return node.classList.contains("is-open");
    });

    return (
      open &&
      open.dataset &&
      open.dataset.section
    )
      ? open.dataset.section
      : "finish";
  }


  /* ==========================================================
     CONFIGURED PRICE
     ========================================================== */

  function priceFromText(text) {
    text = clean(text);

    var matches = text.match(
      /Total price is\s*\$[\d,]+(?:\.\d{2})?/ig
    );

    if (!matches || !matches.length) {
      return "";
    }

    var last =
      matches[matches.length - 1];

    var money = last.match(
      /\$[\d,]+(?:\.\d{2})?/
    );

    return money
      ? money[0]
      : "";
  }


  function configuredPrice() {
    var direct = priceFromText(
      document.body.textContent || ""
    );

    if (direct) {
      return direct;
    }


    var visible = priceFromText(
      document.body.innerText || ""
    );

    if (visible) {
      return visible;
    }


    if (panel) {
      var desktopPrice = q(
        "#sparc-config-price",
        panel
      );

      var desktopText = clean(
        desktopPrice &&
        desktopPrice.textContent
      );

      if (
        /^\$[\d,]+(?:\.\d{2})?$/.test(
          desktopText
        )
      ) {
        return desktopText;
      }
    }


    var fallbackSelectors = [
      "#ProductPrice",
      ".product-single__price",
      ".product__price",
      "[data-product-price]",
      '[itemprop="price"]'
    ];


    for (
      var i = 0;
      i < fallbackSelectors.length;
      i++
    ) {
      var node = q(
        fallbackSelectors[i]
      );

      if (!node) {
        continue;
      }

      var text = clean(
        node.textContent ||
        (
          node.getAttribute &&
          node.getAttribute("content")
        )
      );

      var money = text.match(
        /\$[\d,]+(?:\.\d{2})?/
      );

      if (money) {
        return money[0];
      }
    }


    return "—";
  }


  /* ==========================================================
     LEAD TIME
     ========================================================== */

  function leadText() {
    if (!panel) {
      return "—";
    }

    var node = q(
      "#sparc-config-lead",
      panel
    );

    return (
      clean(
        node &&
        node.textContent
      )
      ||
      "—"
    );
  }


  /* ==========================================================
     PRODUCT NAME
     ========================================================== */

  function productName() {
    var build =
      panel &&
      q(
        ".sparc-build-title",
        panel
      );

    var text = clean(
      build &&
      build.textContent
    );

    if (text) {
      text = text.replace(
        /^build\s+your\s+/i,
        ""
      );
    }

    if (text) {
      return text;
    }


    var title =
      q(
        "#ProductSection h1.product-single__title"
      )
      ||
      q(
        "h1.product-single__title"
      )
      ||
      q(
        "main h1"
      );


    return (
      clean(
        title &&
        title.textContent
      )
      ||
      "Steering Wheel"
    );
  }


  /* ==========================================================
     SERIES
     ========================================================== */

  function findSeriesLink() {
    return qa("a").find(function (node) {
      return (
        clean(node.textContent)
          .toLowerCase()
        ===
        "muscle series"
      );
    }) || null;
  }


  function seriesName() {
    var link =
      findSeriesLink();

    return link
      ? clean(link.textContent)
      : "Muscle Series";
  }


  function seriesHref() {
    var link =
      findSeriesLink();

    return (
      link &&
      link.getAttribute("href")
    )
      ? link.getAttribute("href")
      : "/";
  }


  /* ==========================================================
     SITE LOGO
     ========================================================== */

  function findLogoNode() {
    var selectors = [
      "#shopify-section-header .site-header__logo-image img",
      ".site-header__logo-image img",
      "header img.header__heading-logo",
      "header .header__heading-logo",
      'header [class*="logo"] img',
      'header img[alt*="SPARC" i]',
      '#shopify-section-header img[alt*="SPARC" i]',
      'header [class*="logo"] svg'
    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {
      var node = q(
        selectors[i]
      );

      if (node) {
        return node;
      }
    }


    return null;
  }


  function buildLogoClone() {
    var holder = make(
      "div",
      "sparc-mobile-appbar__brand"
    );

    var source =
      findLogoNode();

    if (!source) {
      return holder;
    }


    var clone =
      source.cloneNode(true);

    clone.removeAttribute("id");


    if (
      clone.tagName &&
      clone.tagName.toLowerCase() ===
      "img"
    ) {
      clone.removeAttribute("width");
      clone.removeAttribute("height");

      clone.className =
        "sparc-mobile-appbar__logo-img";
    } else {
      clone.classList.add(
        "sparc-mobile-appbar__logo-svg"
      );
    }


    holder.appendChild(
      clone
    );

    return holder;
  }


  /* ==========================================================
     HERO IMAGE
     ========================================================== */

  function findHeroImage() {
    var selectors = [
      ".sparc-muscle-hero-column .product-single__photo img",
      ".sparc-muscle-hero-column img.product-single__photo",
      ".sparc-muscle-hero-column .product-single__featured-image-wrapper img",
      "#ProductSection .product-single__featured-image-wrapper img",
      "#ProductSection .product-single__photo img",
      "#ProductSection img.product-single__photo"
    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {
      var node = q(
        selectors[i]
      );

      if (
        node &&
        (
          node.currentSrc ||
          node.src
        )
      ) {
        return node;
      }
    }


    return null;
  }


  /* ==========================================================
     DESCRIPTION
     ========================================================== */

  function findDescriptionSource() {
    var selectors = [
      "#ProductDescription",
      ".product-single__description",
      ".product__description",
      ".product-description",
      '[itemprop="description"]',
      "#ProductSection .rte.product-single__description",
      "#ProductSection .rte"
    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {
      var nodes = qa(
        selectors[i]
      );

      for (
        var j = 0;
        j < nodes.length;
        j++
      ) {
        var node = nodes[j];

        if (
          panel &&
          panel.contains(node)
        ) {
          continue;
        }

        if (
          clean(node.textContent)
            .length >= 25
        ) {
          return node;
        }
      }
    }


    return null;
  }


  /* ==========================================================
     ANCESTOR SAFETY
     ========================================================== */

  function markAncestors() {
    if (!panel) {
      return;
    }

    var parent =
      panel.parentElement;

    while (
      parent &&
      parent !== document.body
    ) {
      parent.classList.add(
        "sparc-mobile-app-ancestor"
      );

      parent =
        parent.parentElement;
    }
  }


  /* ==========================================================
     CART ICON
     ========================================================== */

  function cartIcon() {
    return [
      '<svg viewBox="0 0 24 24" aria-hidden="true">',
      '<path d="M3 4h2l2.1 10.1a2 2 0 0 0 2 1.6h7.8a2 2 0 0 0 1.9-1.4L21 8H7"></path>',
      '<circle cx="10" cy="20" r="1"></circle>',
      '<circle cx="18" cy="20" r="1"></circle>',
      "</svg>"
    ].join("");
  }


  /* ==========================================================
     APP BAR
     ========================================================== */

  function ensureAppBar() {
    var existing = q(
      ".sparc-mobile-appbar",
      panel
    );

    if (existing) {
      appbar = existing;
      return appbar;
    }


    appbar = make(
      "div",
      "sparc-mobile-appbar"
    );


    /* LEFT */

    var left = make(
      "div",
      "sparc-mobile-appbar__left"
    );


    var back = make(
      "button",
      "sparc-mobile-appbar__back",
      "‹"
    );

    back.type = "button";

    back.setAttribute(
      "aria-label",
      "Back"
    );

    back.addEventListener(
      "click",
      function () {
        if (
          window.history.length >
          1
        ) {
          window.history.back();
        } else {
          window.location.href =
            seriesHref();
        }
      }
    );


    var details = make(
      "button",
      "sparc-mobile-appbar__mode",
      "DETAILS"
    );

    details.type = "button";

    details.addEventListener(
      "click",
      toggleMode
    );


    left.appendChild(back);
    left.appendChild(details);


    /* CENTER */

    var brand =
      buildLogoClone();


    /* RIGHT */

    var right = make(
      "div",
      "sparc-mobile-appbar__right"
    );


    var cart = make(
      "button",
      "sparc-mobile-cart-button"
    );

    cart.type = "button";

    cart.setAttribute(
      "aria-label",
      "Cart"
    );

    cart.innerHTML =
      cartIcon();


    var badge = make(
      "span",
      "sparc-mobile-cart-count is-empty",
      "0"
    );

    cart.appendChild(
      badge
    );


    cart.addEventListener(
      "click",
      function () {
        window.location.href =
          "/cart";
      }
    );


    right.appendChild(
      cart
    );


    appbar.appendChild(
      left
    );

    appbar.appendChild(
      brand
    );

    appbar.appendChild(
      right
    );


    panel.insertBefore(
      appbar,
      panel.firstChild
    );


    return appbar;
  }


  /* ==========================================================
     CART COUNT
     ========================================================== */

  function findCartCount() {
    var selectors = [
      "[data-cart-count]",
      ".cart-count-bubble",
      ".site-header__cart-count",
      ".cart-link__bubble-num",
      ".header__cart-count",
      '[class*="cart-count"]'
    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {
      var nodes = qa(
        selectors[i]
      );

      for (
        var j = 0;
        j < nodes.length;
        j++
      ) {
        var node = nodes[j];

        if (
          node.closest &&
          node.closest(
            ".sparc-mobile-appbar"
          )
        ) {
          continue;
        }

        var match = clean(
          node.textContent
        ).match(
          /\d+/
        );

        if (match) {
          return parseInt(
            match[0],
            10
          );
        }
      }
    }


    return 0;
  }


  function updateCartCount() {
    if (!appbar) {
      return;
    }

    var badge = q(
      ".sparc-mobile-cart-count",
      appbar
    );

    if (!badge) {
      return;
    }

    var count =
      findCartCount();

    badge.textContent =
      String(count);

    badge.classList.toggle(
      "is-empty",
      count <= 0
    );
  }


  /* ==========================================================
     HERO
     ========================================================== */

  function ensureHero() {
    var existing = q(
      ".sparc-mobile-hero",
      panel
    );

    if (existing) {
      hero = existing;
      return hero;
    }


    hero = make(
      "section",
      "sparc-mobile-hero"
    );


    /* METRICS */

    var metrics = make(
      "div",
      "sparc-mobile-hero__metrics"
    );


    var priceMetric = make(
      "div",
      "sparc-mobile-hero__metric"
    );

    priceMetric.dataset.metric =
      "price";

    priceMetric.appendChild(
      make(
        "span",
        "sparc-mobile-hero__metric-label",
        "Configured Price"
      )
    );


    var priceValue = make(
      "strong",
      "sparc-mobile-hero__metric-value",
      configuredPrice()
    );

    priceValue.dataset.role =
      "price";

    priceMetric.appendChild(
      priceValue
    );


    var leadMetric = make(
      "div",
      "sparc-mobile-hero__metric"
    );

    leadMetric.dataset.metric =
      "lead";

    leadMetric.appendChild(
      make(
        "span",
        "sparc-mobile-hero__metric-label",
        "Est. Production"
      )
    );


    var leadValue = make(
      "strong",
      "sparc-mobile-hero__metric-value",
      leadText()
    );

    leadValue.dataset.role =
      "lead";

    leadMetric.appendChild(
      leadValue
    );


    metrics.appendChild(
      priceMetric
    );

    metrics.appendChild(
      leadMetric
    );


    /* BREADCRUMB */

    var breadcrumb = make(
      "div",
      "sparc-mobile-hero__breadcrumb"
    );


    var home = make(
      "a",
      "",
      "Home"
    );

    home.href = "/";


    var series = make(
      "a",
      "",
      seriesName()
    );

    series.href =
      seriesHref();


    breadcrumb.appendChild(
      home
    );

    breadcrumb.appendChild(
      make(
        "span",
        "",
        "›"
      )
    );

    breadcrumb.appendChild(
      series
    );

    breadcrumb.appendChild(
      make(
        "span",
        "",
        "›"
      )
    );

    breadcrumb.appendChild(
      make(
        "span",
        "sparc-mobile-hero__breadcrumb-current",
        productName()
      )
    );


    /* MAIN HERO */

    var main = make(
      "div",
      "sparc-mobile-hero__main"
    );


    var copy = make(
      "div",
      "sparc-mobile-hero__copy"
    );


    copy.appendChild(
      make(
        "span",
        "sparc-mobile-hero__eyebrow",
        "CUSTOM CONFIGURATOR"
      )
    );


    var titleGroup = make(
      "div",
      "sparc-mobile-hero__title-group"
    );


    titleGroup.appendChild(
      make(
        "h1",
        "sparc-mobile-hero__title",
        "Build Your " +
        productName()
      )
    );


    titleGroup.appendChild(
      make(
        "div",
        "sparc-mobile-hero__rule"
      )
    );


    var detailsPill = make(
      "button",
      "sparc-mobile-hero__details-pill",
      "Product Details"
    );

    detailsPill.type =
      "button";

    detailsPill.addEventListener(
      "click",
      showDetails
    );


    titleGroup.appendChild(
      detailsPill
    );

    copy.appendChild(
      titleGroup
    );


    var media = make(
      "div",
      "sparc-mobile-hero__media"
    );


    var sourceImage =
      findHeroImage();

    if (sourceImage) {
      var image = make(
        "img",
        "sparc-mobile-hero__image"
      );

      image.alt =
        sourceImage.alt ||
        productName();

      image.src =
        sourceImage.currentSrc ||
        sourceImage.src;

      media.appendChild(
        image
      );
    }


    main.appendChild(
      copy
    );

    main.appendChild(
      media
    );


    hero.appendChild(
      metrics
    );

    hero.appendChild(
      breadcrumb
    );

    hero.appendChild(
      main
    );


    if (
      appbar.nextSibling
    ) {
      panel.insertBefore(
        hero,
        appbar.nextSibling
      );
    } else {
      panel.appendChild(
        hero
      );
    }


    return hero;
  }


  /* ==========================================================
     DESCRIPTION VIEW
     ========================================================== */

  function ensureDescriptionView() {
    var existing = q(
      ".sparc-mobile-description-view",
      panel
    );

    if (existing) {
      descriptionView =
        existing;

      return descriptionView;
    }


    descriptionView = make(
      "section",
      "sparc-mobile-description-view"
    );


    var content = make(
      "div",
      "sparc-mobile-description-view__content"
    );


    var source =
      findDescriptionSource();

    if (source) {
      var clone =
        source.cloneNode(true);

      clone.removeAttribute(
        "id"
      );

      content.appendChild(
        clone
      );
    } else {
      var meta = q(
        'meta[name="description"]'
      );

      if (
        meta &&
        meta.content
      ) {
        content.appendChild(
          make(
            "p",
            "",
            meta.content
          )
        );
      }
    }


    descriptionView.appendChild(
      content
    );


    var back = make(
      "button",
      "sparc-mobile-description-view__back",
      "Back to Configurator"
    );

    back.type = "button";

    back.addEventListener(
      "click",
      showConfigurator
    );


    descriptionView.appendChild(
      back
    );


    var list = q(
      ".sparc-accordion-list",
      panel
    );

    if (list) {
      panel.insertBefore(
        descriptionView,
        list
      );
    } else {
      panel.appendChild(
        descriptionView
      );
    }


    return descriptionView;
  }


  /* ==========================================================
     DETAILS MODE
     ========================================================== */

  function updateModeButton() {
    if (!appbar) {
      return;
    }

    var button = q(
      ".sparc-mobile-appbar__mode",
      appbar
    );

    if (!button) {
      return;
    }

    var details =
      panel.classList.contains(
        "sparc-mobile-mode-details"
      );

    button.textContent =
      details
        ? "BUILD"
        : "DETAILS";

    button.classList.toggle(
      "is-details",
      details
    );

    if (dock) {
      dock.classList.toggle(
        "is-details",
        details
      );
    }
  }


  function showDetails() {
    if (!panel) {
      return;
    }

    ensureDescriptionView();

    configScrollPosition =
      panel.scrollTop;

    panel.classList.add(
      "sparc-mobile-mode-details"
    );

    updateModeButton();

    panel.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }


  function showConfigurator() {
    if (!panel) {
      return;
    }

    panel.classList.remove(
      "sparc-mobile-mode-details"
    );

    updateModeButton();

    window.setTimeout(
      function () {
        panel.scrollTo({
          top: Math.max(
            0,
            configScrollPosition
          ),
          behavior: "smooth"
        });
      },
      40
    );
  }


  function toggleMode() {
    if (
      panel.classList.contains(
        "sparc-mobile-mode-details"
      )
    ) {
      showConfigurator();
    } else {
      showDetails();
    }
  }


  /* ==========================================================
     MOBILE GRID CLASSES
     ========================================================== */

  function decorateGrids() {
    if (!panel) {
      return;
    }

    var grids = qa(
      ".sparc-card-grid," +
      ".sparc-card-grid--2," +
      ".sparc-card-grid--3",
      panel
    );


    grids.forEach(
      function (grid) {
        var cards =
          Array.prototype.filter.call(
            grid.children,
            function (element) {
              return (
                element.classList &&
                element.classList.contains(
                  "sparc-option-card"
                )
              );
            }
          );


        grid.classList.remove(
          "sparc-mobile-grid-count-1",
          "sparc-mobile-grid-count-2",
          "sparc-mobile-grid-count-3",
          "sparc-mobile-grid-count-4"
        );


        var count =
          cards.length;

        if (
          count >= 1 &&
          count <= 4
        ) {
          grid.classList.add(
            "sparc-mobile-grid-count-" +
            count
          );
        } else if (
          count > 4
        ) {
          grid.classList.add(
            "sparc-mobile-grid-count-4"
          );
        }
      }
    );
  }


  /* ==========================================================
     HORN LOGO "INCLUDED"
     ========================================================== */

  function decorateHornCards() {
    var horn =
      section("horn");

    if (!horn) {
      return;
    }


    qa(
      ".sparc-option-card",
      horn
    ).forEach(
      function (card) {
        card.classList.remove(
          "sparc-mobile-horn-included"
        );


        var nameNode = q(
          ".sparc-option-card__name",
          card
        );


        var name = normalize(
          nameNode &&
          nameNode.textContent
        );


        var value = normalize(
          card.getAttribute(
            "data-value"
          )
        );


        var standardLogo =
          name === "sparclogo"
          ||
          value === "sparclogo";


        if (!standardLogo) {
          return;
        }


        var price = q(
          ".sparc-option-card__price",
          card
        );


        if (price) {
          price.textContent =
            "Included";

          card.classList.add(
            "sparc-mobile-horn-included"
          );
        }
      }
    );
  }


  /* ==========================================================
     FINISH + LEATHER IMAGE GEOMETRY

     IMPORTANT:
     CSS controls the image wrapper position.

     JavaScript touches ONLY the actual IMG.
     ========================================================== */

  function resetOptionImages() {
    if (!panel) {
      return;
    }


    var selectors = [
      '.sparc-accordion[data-section="finish"] .sparc-option-card__image img',

      '.sparc-accordion[data-section="leather"] .sparc-card-grid .sparc-option-card__image img',

      '.sparc-accordion[data-section="leather"] .sparc-card-grid--2 .sparc-option-card__image img',

      '.sparc-accordion[data-section="leather"] .sparc-card-grid--3 .sparc-option-card__image img'
    ];


    selectors.forEach(
      function (selector) {
        qa(
          selector,
          panel
        ).forEach(
          function (image) {

            image.style.setProperty(
              "position",
              "absolute",
              "important"
            );

            image.style.setProperty(
              "top",
              "0px",
              "important"
            );

            image.style.setProperty(
              "right",
              "0px",
              "important"
            );

            image.style.setProperty(
              "bottom",
              "0px",
              "important"
            );

            image.style.setProperty(
              "left",
              "0px",
              "important"
            );

            image.style.setProperty(
              "width",
              "100%",
              "important"
            );

            image.style.setProperty(
              "height",
              "100%",
              "important"
            );

            image.style.setProperty(
              "max-width",
              "none",
              "important"
            );

            image.style.setProperty(
              "max-height",
              "none",
              "important"
            );

            image.style.setProperty(
              "margin",
              "0px",
              "important"
            );

            image.style.setProperty(
              "padding",
              "0px",
              "important"
            );

            image.style.setProperty(
              "transform",
              "none",
              "important"
            );

            image.style.setProperty(
              "translate",
              "none",
              "important"
            );

            image.style.setProperty(
              "object-fit",
              "cover",
              "important"
            );

            image.style.setProperty(
              "object-position",
              "center center",
              "important"
            );

            image.style.setProperty(
              "opacity",
              "1",
              "important"
            );

          }
        );
      }
    );
  }


  function decorateCards() {
    decorateGrids();
    decorateHornCards();
    resetOptionImages();
  }


  /* ==========================================================
     REAL ADD TO CART
     ========================================================== */

  function findRealAddToCart() {
    var controls = qa(
      'button,input[type="submit"],a'
    );


    return controls.find(
      function (node) {

        if (
          node.classList &&
          node.classList.contains(
            "sparc-mobile-dock__action"
          )
        ) {
          return false;
        }


        var text = clean(
          (node.textContent || "")
          +
          " "
          +
          (node.value || "")
          +
          " "
          +
          (
            (
              node.getAttribute &&
              node.getAttribute(
                "aria-label"
              )
            )
            ||
            ""
          )
        ).toLowerCase();


        return (
          /add\s+to\s+cart/.test(
            text
          )
          ||
          (
            node.getAttribute &&
            node.getAttribute(
              "name"
            ) ===
            "add"
          )
        );
      }
    ) || null;
  }


  /* ==========================================================
     BOTTOM DOCK
     ========================================================== */

  function ensureDock() {
    var existing = q(
      ".sparc-mobile-dock"
    );

    if (existing) {
      dock = existing;
      return dock;
    }


    dock = make(
      "div",
      "sparc-mobile-dock"
    );


    var priceWrap = make(
      "div",
      "sparc-mobile-dock__price"
    );


    priceWrap.appendChild(
      make(
        "span",
        "sparc-mobile-dock__label",
        "Configured Price"
      )
    );


    priceWrap.appendChild(
      make(
        "strong",
        "sparc-mobile-dock__value",
        configuredPrice()
      )
    );


    var action = make(
      "button",
      "sparc-mobile-dock__action",
      "NEXT STEP"
    );

    action.type = "button";


    action.addEventListener(
      "click",
      function () {

        var current =
          currentOpenName();


        if (
          current ===
          "summary"
        ) {
          var real =
            findRealAddToCart();

          if (real) {
            real.click();
          }

          return;
        }


        var index =
          ORDER.indexOf(
            current
          );


        var nextName =
          (
            index >= 0 &&
            index <
            ORDER.length - 1
          )
            ? ORDER[index + 1]
            : "summary";


        var next =
          section(
            nextName
          );


        var header =
          next &&
          q(
            ".sparc-accordion__head",
            next
          );


        if (!header) {
          return;
        }


        header.click();


        window.setTimeout(
          function () {
            scrollSection(
              next
            );
          },
          90
        );

      }
    );


    dock.appendChild(
      priceWrap
    );

    dock.appendChild(
      action
    );


    document.body.appendChild(
      dock
    );


    return dock;
  }


  /* ==========================================================
     INTERNAL SCROLL
     ========================================================== */

  function scrollSection(node) {
    if (
      !panel ||
      !node
    ) {
      return;
    }


    var panelRect =
      panel.getBoundingClientRect();

    var nodeRect =
      node.getBoundingClientRect();

    var headerHeight =
      appbar
        ? appbar.offsetHeight
        : 58;


    var destination =
      panel.scrollTop
      +
      (
        nodeRect.top -
        panelRect.top
      )
      -
      headerHeight
      -
      8;


    panel.scrollTo({
      top: Math.max(
        0,
        destination
      ),
      behavior: "smooth"
    });
  }


  /* ==========================================================
     ANIMATION HELPERS
     ========================================================== */

  function restartClass(
    node,
    className,
    duration
  ) {
    if (!node) {
      return;
    }

    node.classList.remove(
      className
    );

    void node.offsetWidth;

    node.classList.add(
      className
    );

    window.setTimeout(
      function () {
        node.classList.remove(
          className
        );
      },
      duration
    );
  }


  /* ==========================================================
     LIVE VALUES
     ========================================================== */

  function updateValues() {
    var nextPrice =
      configuredPrice();

    var nextLead =
      leadText();


    if (hero) {
      var heroPrice = q(
        '[data-role="price"]',
        hero
      );

      var heroLead = q(
        '[data-role="lead"]',
        hero
      );


      if (
        heroPrice &&
        clean(
          heroPrice.textContent
        ) !==
        nextPrice
      ) {
        heroPrice.textContent =
          nextPrice;
      }


      if (
        heroLead &&
        clean(
          heroLead.textContent
        ) !==
        nextLead
      ) {
        heroLead.textContent =
          nextLead;
      }
    }


    if (dock) {
      var dockPrice = q(
        ".sparc-mobile-dock__value",
        dock
      );


      if (
        dockPrice &&
        clean(
          dockPrice.textContent
        ) !==
        nextPrice
      ) {
        dockPrice.textContent =
          nextPrice;
      }
    }


    if (!firstValueSync) {

      if (
        nextPrice &&
        nextPrice !== "—" &&
        lastPrice &&
        nextPrice !== lastPrice
      ) {

        if (hero) {
          restartClass(
            q(
              '[data-role="price"]',
              hero
            ),
            "sparc-mobile-price-change-active",
            760
          );
        }

        if (dock) {
          restartClass(
            q(
              ".sparc-mobile-dock__value",
              dock
            ),
            "sparc-mobile-price-change-active",
            760
          );
        }

      }


      if (
        nextLead &&
        nextLead !== "—" &&
        lastLead &&
        nextLead !== lastLead
      ) {

        if (hero) {
          restartClass(
            q(
              '[data-metric="lead"]',
              hero
            ),
            "sparc-mobile-production-change-active",
            2750
          );

          restartClass(
            q(
              '[data-role="lead"]',
              hero
            ),
            "sparc-mobile-production-value-active",
            2750
          );
        }

      }

    }


    if (
      nextPrice &&
      nextPrice !== "—"
    ) {
      lastPrice =
        nextPrice;
    }


    if (
      nextLead &&
      nextLead !== "—"
    ) {
      lastLead =
        nextLead;
    }


    firstValueSync =
      false;
  }


  function updateDockButton() {
    if (!dock) {
      return;
    }

    var action = q(
      ".sparc-mobile-dock__action",
      dock
    );

    if (!action) {
      return;
    }

    action.textContent =
      currentOpenName() ===
      "summary"
        ? "ADD TO CART"
        : "NEXT STEP";
  }


  /* ==========================================================
     MOBILE LOADING LOGO
     ========================================================== */

  function ensureLoadingLogo() {
    if (!isPhone()) {
      return;
    }


    var loader =
      document.getElementById(
        "sparc-configurator-loader"
      );


    if (!loader) {
      return;
    }


    if (
      q(
        ".sparc-mobile-loading-logo",
        loader
      )
    ) {
      return;
    }


    var source =
      findLogoNode();

    if (!source) {
      return;
    }


    var holder = make(
      "div",
      "sparc-mobile-loading-logo"
    );


    var clone =
      source.cloneNode(true);

    clone.removeAttribute(
      "id"
    );


    if (
      clone.removeAttribute
    ) {
      clone.removeAttribute(
        "width"
      );

      clone.removeAttribute(
        "height"
      );
    }


    holder.appendChild(
      clone
    );


    loader.appendChild(
      holder
    );
  }


  /* ==========================================================
     CLEAN OLD MOBILE UI
     ========================================================== */

  function cleanOldMobileDom() {
    if (!panel) {
      return;
    }


    [
      ".sparc-mobile-appbar",
      ".sparc-mobile-hero",
      ".sparc-mobile-description-view",
      ".sparc-mobile-quick-status"
    ].forEach(
      function (selector) {

        qa(
          selector,
          panel
        ).forEach(
          function (node) {
            node.remove();
          }
        );

      }
    );


    qa(
      ".sparc-mobile-dock"
    ).forEach(
      function (node) {
        node.remove();
      }
    );
  }


  /* ==========================================================
     SYNC
     ========================================================== */

  function syncAll() {
    if (
      !panel ||
      !isPhone()
    ) {
      return;
    }

    updateValues();
    updateDockButton();
    updateModeButton();
    updateCartCount();
    decorateCards();
    ensureLoadingLogo();
  }


  function scheduleSync() {
    window.clearTimeout(
      syncTimer
    );

    syncTimer =
      window.setTimeout(
        syncAll,
        60
      );
  }


  /* ==========================================================
     EVENTS
     ========================================================== */

  function installEvents() {
    if (
      eventsInstalled ||
      !panel
    ) {
      return;
    }


    eventsInstalled = true;


    panel.addEventListener(
      "click",
      scheduleSync,
      true
    );

    panel.addEventListener(
      "input",
      scheduleSync,
      true
    );

    panel.addEventListener(
      "change",
      scheduleSync,
      true
    );

    document.addEventListener(
      "change",
      scheduleSync,
      true
    );

    document.addEventListener(
      "input",
      scheduleSync,
      true
    );
  }


  /* ==========================================================
     OBSERVER
     ========================================================== */

  function installObserver() {
    if (observer) {
      observer.disconnect();
    }


    var root =
      q("#ProductSection")
      ||
      q(
        'form[action*="/cart/add"]'
      )
      ||
      document.body;


    observer =
      new MutationObserver(
        scheduleSync
      );


    observer.observe(
      root,
      {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: [
          "class",
          "value",
          "style",
          "aria-hidden",
          "aria-expanded"
        ]
      }
    );
  }


  /* ==========================================================
     BACKUP SYNC
     ========================================================== */

  function installBackupSync() {
    if (syncInterval) {
      window.clearInterval(
        syncInterval
      );
    }


    syncInterval =
      window.setInterval(
        function () {
          if (
            isPhone() &&
            panel
          ) {
            syncAll();
          }
        },
        350
      );
  }


  /* ==========================================================
     ACTIVATE
     ========================================================== */

  function activate() {
    if (!isPhone()) {
      return false;
    }


    panel =
      getPanel();

    if (!panel) {
      return false;
    }


    cleanOldMobileDom();


    document.documentElement
      .classList.add(
        "sparc-mobile-app-active"
      );


    document.body
      .classList.add(
        "sparc-mobile-app-active"
      );


    panel.classList.add(
      "sparc-mobile-app-panel"
    );


    panel.classList.remove(
      "sparc-mobile-mode-details"
    );


    panel.classList.add(
      "sparc-mobile-mode-config"
    );


    markAncestors();


    ensureAppBar();
    ensureHero();
    ensureDescriptionView();
    ensureDock();

    decorateCards();

    ensureLoadingLogo();

    installEvents();
    installObserver();
    installBackupSync();


    syncAll();


    window.setTimeout(
      syncAll,
      150
    );

    window.setTimeout(
      syncAll,
      400
    );

    window.setTimeout(
      syncAll,
      900
    );


    console.info(
      "[SPARC MOBILE V4 BASELINE] Active."
    );


    return true;
  }


  /* ==========================================================
     START
     ========================================================== */

  function start() {
    if (!isPhone()) {
      return;
    }


    var attempts = 0;


    var timer =
      window.setInterval(
        function () {
          attempts++;


          if (
            activate()
            ||
            attempts >= 80
          ) {
            window.clearInterval(
              timer
            );
          }
        },
        250
      );
  }


  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }

})();